import React, { useState } from 'react';
import { Button } from './ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ConsultationForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    caseType: '',
    description: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Send to backend (you'll need to create this endpoint)
      await axios.post(`${API}/consultation-request`, formData);
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', caseType: '', description: '' });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Помилка відправки форми. Будь ласка, спробуйте пізніше або зателефонуйте нам.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="consultation" className="section-container">
      <div className="content-wrapper">
        <div className="consultation-container">
          <div className="consultation-info">
            <h2 className="section-title">Безкоштовна консультація</h2>
            <p className="consultation-subtitle">
              Заповніть форму, і наш юрист зв'яжеться з вами протягом 24 годин для первинної оцінки вашої ситуації.
            </p>
            <div className="consultation-benefits">
              <div className="benefit-item">
                <span className="benefit-check">✓</span>
                <span>Конфіденційно</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-check">✓</span>
                <span>Швидка відповідь</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-check">✓</span>
                <span>Без зобов'язань</span>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="consultation-form">
            {submitted && (
              <div className="form-success">
                ✓ Дякуємо! Ми зв'яжемося з вами найближчим часом.
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="name">Ім'я *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Ваше ім'я"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="example@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Телефон *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="+380 XX XXX XX XX"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="caseType">Тип справи</label>
              <select
                id="caseType"
                name="caseType"
                value={formData.caseType}
                onChange={handleChange}
              >
                <option value="">Оберіть тип справи</option>
                <option value="corporate">Корпоративне право</option>
                <option value="litigation">Судові спори</option>
                <option value="tax">Податкове право</option>
                <option value="commercial">Господарські справи</option>
                <option value="other">Інше</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="description">Опис ситуації *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
                rows="4"
                placeholder="Коротко опишіть вашу ситуацію..."
              />
            </div>

            <Button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Відправка...' : 'Відправити запит'}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ConsultationForm;